// usuarioService.js
import axios from 'axios';
import swal from 'sweetalert';

const API_URL = 'http://localhost:8080/api/v1/usuarios/disponibles/';

function validarCreacionUsuario(idEmpresa, idSuscripcion) {
  return axios.get(`${API_URL}${idEmpresa}/${idSuscripcion}`)
    .then(response => {
      const contador = response.data;
      return contador > 0;
    })
    .catch(error => {
      console.error("Error en la petición: ", error);
      swal("Error!", "Problema al obtener la cantidad de usuarios.", "error");
      return false;
    });
}

export { validarCreacionUsuario };
